import * as addAsset from './assets/add-asset.icon.svg';
import * as addSmall from './assets/add-small.icon.svg';
import * as addSolid from './assets/add-solid.icon.svg';
import * as add from './assets/add.icon.svg';
import * as aggregate from './assets/aggregate.icon.svg';
import * as at from './assets/at.icon.svg';
import * as attrShape00 from './assets/attr-shape-00.icon.svg';
import * as attrShape01 from './assets/attr-shape-01.icon.svg';
import * as attrShape02 from './assets/attr-shape-02.icon.svg';
import * as attrShape03 from './assets/attr-shape-03.icon.svg';
import * as attrShape04 from './assets/attr-shape-04.icon.svg';
import * as attrShape05 from './assets/attr-shape-05.icon.svg';
import * as attrShape06 from './assets/attr-shape-06.icon.svg';
import * as attrShape07 from './assets/attr-shape-07.icon.svg';
import * as attrShape08 from './assets/attr-shape-08.icon.svg';
import * as attrShape09 from './assets/attr-shape-09.icon.svg';
import * as attrShape10 from './assets/attr-shape-10.icon.svg';
import * as attrShape11 from './assets/attr-shape-11.icon.svg';
import * as attrShape12 from './assets/attr-shape-12.icon.svg';
import * as attrShape13 from './assets/attr-shape-13.icon.svg';
import * as attrShape14 from './assets/attr-shape-14.icon.svg';
import * as attrShape15 from './assets/attr-shape-15.icon.svg';
import * as attrShape16 from './assets/attr-shape-16.icon.svg';
import * as autoCalc from './assets/auto-calc.icon.svg';
import * as blank from './assets/blank.icon.svg';
import * as blendTypeFull from './assets/blend-type-full.icon.svg';
import * as blendTypeInner from './assets/blend-type-inner.icon.svg';
import * as blendTypeLeft from './assets/blend-type-left.icon.svg';
import * as blendTypeRight from './assets/blend-type-right.icon.svg';
import * as blendTypeSelf from './assets/blend-type-self.icon.svg';
import * as cacheRefreshNext from './assets/cache-refresh-next.icon.svg';
import * as canceledSolid from './assets/canceled-solid.icon.svg';
import * as checkCircleHalf from './assets/check-circle-half.icon.svg';
import * as checkCircleOutline from './assets/check-circle-outline.icon.svg';
import * as checkCircleSolid from './assets/check-circle-solid.icon.svg';
import * as checkSmall from './assets/check-small.icon.svg';
import * as checkmark from './assets/checkmark.icon.svg';
import * as chevronDownBig from './assets/chevron-down-big.icon.svg';
import * as chevronDown from './assets/chevron-down.icon.svg';
import * as chevronLeftBig from './assets/chevron-left-big.icon.svg';
import * as chevronLeft from './assets/chevron-left.icon.svg';
import * as chevronRightBig from './assets/chevron-right-big.icon.svg';
import * as chevronRight from './assets/chevron-right.icon.svg';
import * as chevronUpBig from './assets/chevron-up-big.icon.svg';
import * as chevronUp from './assets/chevron-up.icon.svg';
import * as childLine from './assets/child-line.icon.svg';
import * as clock from './assets/clock.icon.svg';
import * as closeSmall from './assets/close-small.icon.svg';
import * as close from './assets/close.icon.svg';
import * as collaborator from './assets/collaborator.icon.svg';
import * as collapse from './assets/collapse.icon.svg';
import * as column from './assets/column.icon.svg';
import * as comment from './assets/comment.icon.svg';
import * as configure from './assets/configure.icon.svg';
import * as connections from './assets/connections.icon.svg';
import * as contact from './assets/contact.icon.svg';
import * as copy from './assets/copy.icon.svg';
import * as dashDash from './assets/dash-dash.icon.svg';
import * as dataTrigger from './assets/data-trigger.icon.svg';
import * as data from './assets/data.icon.svg';
import * as database from './assets/database.icon.svg';
import * as datameer from './assets/datameer.icon.svg';
import * as datasourceReference from './assets/datasource-reference.icon.svg';
import * as dataspace from './assets/dataspace.icon.svg';
import * as dbt from './assets/dbt.icon.svg';
import * as deleteIcon from './assets/delete.icon.svg';
import * as deployModel from './assets/deploy-model.icon.svg';
import * as deployed from './assets/deployed.icon.svg';
import * as deployment from './assets/deployment.icon.svg';
import * as disconnected from './assets/disconnected.icon.svg';
import * as document from './assets/document.icon.svg';
import * as download from './assets/download.icon.svg';
import * as draftModel from './assets/draft-model.icon.svg';
import * as drag from './assets/drag.icon.svg';
import * as dropdownClose from './assets/dropdown-close.icon.svg';
import * as dropdownOpen from './assets/dropdown-open.icon.svg';
import * as dynamicTable from './assets/dynamic-table.icon.svg';
import * as edit from './assets/edit.icon.svg';
import * as envVariables from './assets/env-variables.icon.svg';
import * as errorSolid from './assets/error-solid.icon.svg';
import * as eventTrigger from './assets/event-trigger.icon.svg';
import * as everyone from './assets/everyone.icon.svg';
import * as expand from './assets/expand.icon.svg';
import * as explore from './assets/explore.icon.svg';
import * as exportIcon from './assets/export.icon.svg';
import * as external from './assets/external.icon.svg';
import * as extract from './assets/extract.icon.svg';
import * as filter from './assets/filter.icon.svg';
import * as fitToScreen from './assets/fit-to-screen.icon.svg';
import * as flow from './assets/flow.icon.svg';
import * as folderUpload from './assets/folder-upload.icon.svg';
import * as folder from './assets/folder.icon.svg';
import * as fullscreen from './assets/fullscreen.icon.svg';
import * as functionIcon from './assets/function.icon.svg';
import * as gettingStarted from './assets/getting-started.icon.svg';
import * as githubLogo from './assets/github-logo.icon.svg';
import * as glossary from './assets/glossary.icon.svg';
import * as googleLogo from './assets/google-logo.icon.svg';
import * as google from './assets/google.icon.svg';
import * as helpInfoSolid from './assets/help-info-solid.icon.svg';
import * as helpOutline from './assets/help-outline.icon.svg';
import * as helpSolid from './assets/help-solid.icon.svg';
import * as help from './assets/help.icon.svg';
import * as history from './assets/history.icon.svg';
import * as homeSolid from './assets/home-solid.icon.svg';
import * as home from './assets/home.icon.svg';
import * as howTo from './assets/how-to.icon.svg';
import * as indicatorDataSampled from './assets/indicator-data-sampled.icon.svg';
import * as indicatorPaused from './assets/indicator-paused.icon.svg';
import * as indicatorScheduled from './assets/indicator-scheduled.icon.svg';
import * as indicatorTriggerApi from './assets/indicator-trigger-api.icon.svg';
import * as indicatorTriggerData from './assets/indicator-trigger-data.icon.svg';
import * as infoSolid from './assets/info-solid.icon.svg';
import * as info from './assets/info.icon.svg';
import * as insert from './assets/insert.icon.svg';
import * as integrate from './assets/integrate.icon.svg';
import * as jobCloud from './assets/job-cloud.icon.svg';
import * as jobMaterializationTable from './assets/job-materialization-table.icon.svg';
import * as jobSystem from './assets/job-system.icon.svg';
import * as job from './assets/job.icon.svg';
import * as json from './assets/json.icon.svg';
import * as jupyter from './assets/jupyter.icon.svg';
import * as knowledgeBase from './assets/knowledge-base.icon.svg';
import * as likeSolid from './assets/like-solid.icon.svg';
import * as like from './assets/like.icon.svg';
import * as lineChart from './assets/line-chart.icon.svg';
import * as linkUrl from './assets/link-url.icon.svg';
import * as lockedSolid from './assets/locked-solid.icon.svg';
import * as locked from './assets/locked.icon.svg';
import * as login from './assets/login.icon.svg';
import * as logout from './assets/logout.icon.svg';
import * as mail from './assets/mail.icon.svg';
import * as metricMax from './assets/metric-max.icon.svg';
import * as metricMean from './assets/metric-mean.icon.svg';
import * as metricMin from './assets/metric-min.icon.svg';
import * as metricUnique from './assets/metric-unique.icon.svg';
import * as metrics from './assets/metrics.icon.svg';
import * as migrate from './assets/migrate.icon.svg';
import * as minus from './assets/minus.icon.svg';
import * as modelJob from './assets/model-job.icon.svg';
import * as modelLetter from './assets/model-letter.icon.svg';
import * as modelTable from './assets/model-table.icon.svg';
import * as moreHorizontal from './assets/more-horizontal.icon.svg';
import * as more from './assets/more.icon.svg';
import * as move from './assets/move.icon.svg';
import * as navBack from './assets/nav-back.icon.svg';
import * as navDown from './assets/nav-down.icon.svg';
import * as navForward from './assets/nav-forward.icon.svg';
import * as navUp from './assets/nav-up.icon.svg';
import * as neebo from './assets/neebo.icon.svg';
import * as opBlend from './assets/op-blend.icon.svg';
import * as opExtractJson from './assets/op-extract-json.icon.svg';
import * as opExtract from './assets/op-extract.icon.svg';
import * as opManageColumns from './assets/op-manage-columns.icon.svg';
import * as opRename from './assets/op-rename.icon.svg';
import * as opReplace from './assets/op-replace.icon.svg';
import * as opSessionize from './assets/op-sessionize.icon.svg';
import * as opSplit from './assets/op-split.icon.svg';
import * as opSql from './assets/op-sql.icon.svg';
import * as opUnion from './assets/op-union.icon.svg';
import * as openaiLogo from './assets/openai-logo.icon.svg';
import * as ownership from './assets/ownership.icon.svg';
import * as paperclip from './assets/paperclip.icon.svg';
import * as passwordHide from './assets/password-hide.icon.svg';
import * as passwordShow from './assets/password-show.icon.svg';
import * as pause from './assets/pause.icon.svg';
import * as pivot from './assets/pivot.icon.svg';
import * as play from './assets/play.icon.svg';
import * as plus from './assets/plus.icon.svg';
import * as pointer from './assets/pointer.icon.svg';
import * as preview from './assets/preview.icon.svg';
import * as profile from './assets/profile.icon.svg';
import * as readOnly from './assets/read-only.icon.svg';
import * as redo from './assets/redo.icon.svg';
import * as resizeHandler from './assets/resize-handler.icon.svg';
import * as restore from './assets/restore.icon.svg';
import * as returnKey from './assets/return-key.icon.svg';
import * as role from './assets/role.icon.svg';
import * as rows from './assets/rows.icon.svg';
import * as s3 from './assets/s3.icon.svg';
import * as salesforce from './assets/salesforce.icon.svg';
import * as schemaMap from './assets/schema-map.icon.svg';
import * as schema from './assets/schema.icon.svg';
import * as search from './assets/search.icon.svg';
import * as selectAsset from './assets/select-asset.icon.svg';
import * as settings from './assets/settings.icon.svg';
import * as showMap from './assets/show-map.icon.svg';
import * as sidepanelCollapse from './assets/sidepanel-collapse.icon.svg';
import * as sidepanelExpand from './assets/sidepanel-expand.icon.svg';
import * as sigma from './assets/sigma.icon.svg';
import * as slackLogo from './assets/slack-logo.icon.svg';
import * as slack from './assets/slack.icon.svg';
import * as snowflakeStrong from './assets/snowflake-strong.icon.svg';
import * as snowflake from './assets/snowflake.icon.svg';
import * as sort from './assets/sort.icon.svg';
import * as sourceNotAvailable from './assets/source-not-available.icon.svg';
import * as speechBubbleEmpty from './assets/speech-bubble-empty.icon.svg';
import * as sqlSmall from './assets/sql-small.icon.svg';
import * as statusAlertSolid from './assets/status-alert-solid.icon.svg';
import * as statusAlert from './assets/status-alert.icon.svg';
import * as statusWarningSolid from './assets/status-warning-solid.icon.svg';
import * as statusWarning from './assets/status-warning.icon.svg';
import * as student from './assets/student.icon.svg';
import * as submitSolid from './assets/submit-solid.icon.svg';
import * as submit from './assets/submit.icon.svg';
import * as system from './assets/system.icon.svg';
import * as table from './assets/table.icon.svg';
import * as tableau from './assets/tableau.icon.svg';
import * as target from './assets/target.icon.svg';
import * as thumbUp from './assets/thumb-up.icon.svg';
import * as tools from './assets/tools.icon.svg';
import * as transformStack from './assets/transform-stack.icon.svg';
import * as transform from './assets/transform.icon.svg';
import * as typeArray from './assets/type-array.icon.svg';
import * as typeBoolean from './assets/type-boolean.icon.svg';
import * as typeComplex from './assets/type-complex.icon.svg';
import * as typeDate from './assets/type-date.icon.svg';
import * as typeDecimal from './assets/type-decimal.icon.svg';
import * as typeDouble from './assets/type-double.icon.svg';
import * as typeFloat from './assets/type-float.icon.svg';
import * as typeGeography from './assets/type-geography.icon.svg';
import * as typeInteger from './assets/type-integer.icon.svg';
import * as typeObject from './assets/type-object.icon.svg';
import * as typeString from './assets/type-string.icon.svg';
import * as typeTime from './assets/type-time.icon.svg';
import * as typeTimestamp from './assets/type-timestamp.icon.svg';
import * as typeUnsupported from './assets/type-unsupported.icon.svg';
import * as typeVariant from './assets/type-variant.icon.svg';
import * as undo from './assets/undo.icon.svg';
import * as unionActive from './assets/union-active.icon.svg';
import * as unionAllActive from './assets/union-all-active.icon.svg';
import * as unionAll from './assets/union-all.icon.svg';
import * as unionExceptActive from './assets/union-except-active.icon.svg';
import * as unionExcept from './assets/union-except.icon.svg';
import * as unionIntersectActive from './assets/union-intersect-active.icon.svg';
import * as unionIntersect from './assets/union-intersect.icon.svg';
import * as union from './assets/union.icon.svg';
import * as unlockedSolid from './assets/unlocked-solid.icon.svg';
import * as unlocked from './assets/unlocked.icon.svg';
import * as update from './assets/update.icon.svg';
import * as uplevel from './assets/uplevel.icon.svg';
import * as upload from './assets/upload.icon.svg';
import * as usage from './assets/usage.icon.svg';
import * as userManual from './assets/user-manual.icon.svg';
import * as versionLetter from './assets/version-letter.icon.svg';
import * as video from './assets/video.icon.svg';
import * as viewHistory from './assets/view-history.icon.svg';
import * as view from './assets/view.icon.svg';
import * as walkThru from './assets/walk-thru.icon.svg';
import * as warehouse from './assets/warehouse.icon.svg';

export const sprites = {
    'add-asset': addAsset.default,
    'add-small': addSmall.default,
    'add-solid': addSolid.default,
    'add': add.default,
    'aggregate': aggregate.default,
    'at': at.default,
    'attr-shape-00': attrShape00.default,
    'attr-shape-01': attrShape01.default,
    'attr-shape-02': attrShape02.default,
    'attr-shape-03': attrShape03.default,
    'attr-shape-04': attrShape04.default,
    'attr-shape-05': attrShape05.default,
    'attr-shape-06': attrShape06.default,
    'attr-shape-07': attrShape07.default,
    'attr-shape-08': attrShape08.default,
    'attr-shape-09': attrShape09.default,
    'attr-shape-10': attrShape10.default,
    'attr-shape-11': attrShape11.default,
    'attr-shape-12': attrShape12.default,
    'attr-shape-13': attrShape13.default,
    'attr-shape-14': attrShape14.default,
    'attr-shape-15': attrShape15.default,
    'attr-shape-16': attrShape16.default,
    'auto-calc': autoCalc.default,
    'blank': blank.default,
    'blend-type-full': blendTypeFull.default,
    'blend-type-inner': blendTypeInner.default,
    'blend-type-left': blendTypeLeft.default,
    'blend-type-right': blendTypeRight.default,
    'blend-type-self': blendTypeSelf.default,
    'cache-refresh-next': cacheRefreshNext.default,
    'canceled-solid': canceledSolid.default,
    'check-circle-half': checkCircleHalf.default,
    'check-circle-outline': checkCircleOutline.default,
    'check-circle-solid': checkCircleSolid.default,
    'check-small': checkSmall.default,
    'checkmark': checkmark.default,
    'chevron-down-big': chevronDownBig.default,
    'chevron-down': chevronDown.default,
    'chevron-left-big': chevronLeftBig.default,
    'chevron-left': chevronLeft.default,
    'chevron-right-big': chevronRightBig.default,
    'chevron-right': chevronRight.default,
    'chevron-up-big': chevronUpBig.default,
    'chevron-up': chevronUp.default,
    'child-line': childLine.default,
    'clock': clock.default,
    'close-small': closeSmall.default,
    'close': close.default,
    'collaborator': collaborator.default,
    'collapse': collapse.default,
    'column': column.default,
    'comment': comment.default,
    'configure': configure.default,
    'connections': connections.default,
    'contact': contact.default,
    'copy': copy.default,
    'dash-dash': dashDash.default,
    'data-trigger': dataTrigger.default,
    'data': data.default,
    'database': database.default,
    'datameer': datameer.default,
    'datasource-reference': datasourceReference.default,
    'dataspace': dataspace.default,
    'dbt': dbt.default,
    'delete': deleteIcon.default,
    'deploy-model': deployModel.default,
    'deployed': deployed.default,
    'deployment': deployment.default,
    'disconnected': disconnected.default,
    'document': document.default,
    'download': download.default,
    'draft-model': draftModel.default,
    'drag': drag.default,
    'dropdown-close': dropdownClose.default,
    'dropdown-open': dropdownOpen.default,
    'dynamic-table': dynamicTable.default,
    'edit': edit.default,
    'env-variables': envVariables.default,
    'error-solid': errorSolid.default,
    'event-trigger': eventTrigger.default,
    'everyone': everyone.default,
    'expand': expand.default,
    'explore': explore.default,
    'export': exportIcon.default,
    'external': external.default,
    'extract': extract.default,
    'filter': filter.default,
    'fit-to-screen': fitToScreen.default,
    'flow': flow.default,
    'folder-upload': folderUpload.default,
    'folder': folder.default,
    'fullscreen': fullscreen.default,
    'function': functionIcon.default,
    'getting-started': gettingStarted.default,
    'github-logo': githubLogo.default,
    'glossary': glossary.default,
    'google-logo': googleLogo.default,
    'google': google.default,
    'help-info-solid': helpInfoSolid.default,
    'help-outline': helpOutline.default,
    'help-solid': helpSolid.default,
    'help': help.default,
    'history': history.default,
    'home-solid': homeSolid.default,
    'home': home.default,
    'how-to': howTo.default,
    'indicator-data-sampled': indicatorDataSampled.default,
    'indicator-paused': indicatorPaused.default,
    'indicator-scheduled': indicatorScheduled.default,
    'indicator-trigger-api': indicatorTriggerApi.default,
    'indicator-trigger-data': indicatorTriggerData.default,
    'info-solid': infoSolid.default,
    'info': info.default,
    'insert': insert.default,
    'integrate': integrate.default,
    'job-cloud': jobCloud.default,
    'job-materialization-table': jobMaterializationTable.default,
    'job-system': jobSystem.default,
    'job': job.default,
    'json': json.default,
    'jupyter': jupyter.default,
    'knowledge-base': knowledgeBase.default,
    'like-solid': likeSolid.default,
    'like': like.default,
    'line-chart': lineChart.default,
    'link-url': linkUrl.default,
    'locked-solid': lockedSolid.default,
    'locked': locked.default,
    'login': login.default,
    'logout': logout.default,
    'mail': mail.default,
    'metric-max': metricMax.default,
    'metric-mean': metricMean.default,
    'metric-min': metricMin.default,
    'metric-unique': metricUnique.default,
    'metrics': metrics.default,
    'migrate': migrate.default,
    'minus': minus.default,
    'model-job': modelJob.default,
    'model-letter': modelLetter.default,
    'model-table': modelTable.default,
    'more-horizontal': moreHorizontal.default,
    'more': more.default,
    'move': move.default,
    'nav-back': navBack.default,
    'nav-down': navDown.default,
    'nav-forward': navForward.default,
    'nav-up': navUp.default,
    'neebo': neebo.default,
    'op-blend': opBlend.default,
    'op-extract-json': opExtractJson.default,
    'op-extract': opExtract.default,
    'op-manage-columns': opManageColumns.default,
    'op-rename': opRename.default,
    'op-replace': opReplace.default,
    'op-sessionize': opSessionize.default,
    'op-split': opSplit.default,
    'op-sql': opSql.default,
    'op-union': opUnion.default,
    'openai-logo': openaiLogo.default,
    'ownership': ownership.default,
    'paperclip': paperclip.default,
    'password-hide': passwordHide.default,
    'password-show': passwordShow.default,
    'pause': pause.default,
    'pivot': pivot.default,
    'play': play.default,
    'plus': plus.default,
    'pointer': pointer.default,
    'preview': preview.default,
    'profile': profile.default,
    'read-only': readOnly.default,
    'redo': redo.default,
    'resize-handler': resizeHandler.default,
    'restore': restore.default,
    'return-key': returnKey.default,
    'role': role.default,
    'rows': rows.default,
    's3': s3.default,
    'salesforce': salesforce.default,
    'schema-map': schemaMap.default,
    'schema': schema.default,
    'search': search.default,
    'select-asset': selectAsset.default,
    'settings': settings.default,
    'show-map': showMap.default,
    'sidepanel-collapse': sidepanelCollapse.default,
    'sidepanel-expand': sidepanelExpand.default,
    'sigma': sigma.default,
    'slack-logo': slackLogo.default,
    'slack': slack.default,
    'snowflake-strong': snowflakeStrong.default,
    'snowflake': snowflake.default,
    'sort': sort.default,
    'source-not-available': sourceNotAvailable.default,
    'speech-bubble-empty': speechBubbleEmpty.default,
    'sql-small': sqlSmall.default,
    'status-alert-solid': statusAlertSolid.default,
    'status-alert': statusAlert.default,
    'status-warning-solid': statusWarningSolid.default,
    'status-warning': statusWarning.default,
    'student': student.default,
    'submit-solid': submitSolid.default,
    'submit': submit.default,
    'system': system.default,
    'table': table.default,
    'tableau': tableau.default,
    'target': target.default,
    'thumb-up': thumbUp.default,
    'tools': tools.default,
    'transform-stack': transformStack.default,
    'transform': transform.default,
    'type-array': typeArray.default,
    'type-boolean': typeBoolean.default,
    'type-complex': typeComplex.default,
    'type-date': typeDate.default,
    'type-decimal': typeDecimal.default,
    'type-double': typeDouble.default,
    'type-float': typeFloat.default,
    'type-geography': typeGeography.default,
    'type-integer': typeInteger.default,
    'type-object': typeObject.default,
    'type-string': typeString.default,
    'type-time': typeTime.default,
    'type-timestamp': typeTimestamp.default,
    'type-unsupported': typeUnsupported.default,
    'type-variant': typeVariant.default,
    'undo': undo.default,
    'union-active': unionActive.default,
    'union-all-active': unionAllActive.default,
    'union-all': unionAll.default,
    'union-except-active': unionExceptActive.default,
    'union-except': unionExcept.default,
    'union-intersect-active': unionIntersectActive.default,
    'union-intersect': unionIntersect.default,
    'union': union.default,
    'unlocked-solid': unlockedSolid.default,
    'unlocked': unlocked.default,
    'update': update.default,
    'uplevel': uplevel.default,
    'upload': upload.default,
    'usage': usage.default,
    'user-manual': userManual.default,
    'version-letter': versionLetter.default,
    'video': video.default,
    'view-history': viewHistory.default,
    'view': view.default,
    'walk-thru': walkThru.default,
    'warehouse': warehouse.default
} as const;
